import "./experience.css";
import Heading from "../../heading/Heading";
import Courses from "./courses/Courses";
import Certifications from "./certifications/Certifications";
import Skills from "./skills/Skills";

const Experience = () => {
  return (
    <div className="experience" id="experience">
      <Heading word="Experience" headingSize="h1" />
      <Skills />
      <Courses />
      <Certifications />
    </div>
  );
};

export default Experience;
